<!-- Animierte Liquid-Vorschau (Interface-Seite). Gleiche Klassen wie im Widget
     (chat-widget › command-widget), Zustände setzt liquid-demo.component.ts. -->
<div
  #stage
  class="ld-stage"
  [class.ld-stage--bar]="scenario === 'bar'"
  [class.ld-stage--aid]="scenario === 'aid'"
  [class.ld-off]="!on"
  [style.font-family]="styles.fontFamily || 'Roboto, sans-serif'"
  aria-hidden="true"
>
  <div
    #root
    class="ld-oc"
    data-state="closed"
    data-canvas="closed"
    [style.--oc-app-bg]="paint.primaryFill"
    [style.--oc-app-icon]="appIconColor"
    [style.--oc-goo-fill]="paint.primaryInk"
    [style.--oc-rim]="paint.primaryInk"
    [style.--oc-accent-ink]="paint.primaryInk"
    [style.--ld-secondary]="paint.secondaryFill"
  >
    <!-- Canvas -->
    <section #canvas class="oc-canvas" [style.background]="paint.windowFill">
      <header class="oc-canvas__head">
        <img *ngIf="styles.logo" class="oc-canvas__logo" [src]="styles.logo" alt="" [style.height.px]="(styles.logoSize || 24) > 28 ? 28 : (styles.logoSize || 24)" />
        <span class="oc-tools">
          <span class="oc-tool"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4.2-4.2" /></svg></span>
          <span class="oc-tool"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M14 4h4.5A2.5 2.5 0 0 1 21 6.5v11a2.5 2.5 0 0 1-2.5 2.5H14z" class="oc-fill" /></svg></span>
          <span class="oc-tool"><svg viewBox="0 0 24 24"><path d="M6 12h12" /></svg></span>
          <span class="oc-tool oc-tool--close"><svg viewBox="0 0 24 24"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" /></svg></span>
        </span>
      </header>
      <div class="oc-canvas__body">
        <!-- Chat. Nicht per @if: der Inhalt (Szenario 'aid': die Lernhilfe)
             wird hier hineinprojiziert, und ng-content darf nicht bedingt stehen. -->
        <div #chat class="ld-chat" [class.ld-chat--aid]="scenario === 'aid'" [class.is-hidden]="view !== 'chat'">
          <ng-container *ngIf="scenario !== 'aid'">
            <div class="ld-msg ld-msg--user" [style.background]="paint.userBubbleFill" [style.color]="paint.userTextInk">{{
              'pages.chatStyling.preview.sampleUserMessage' | translate
            }}</div>
            <div class="ld-msg ld-msg--bot" [style.background]="paint.secondaryFill" [style.color]="paint.botTextInk">{{
              'pages.chatStyling.preview.sampleBotMessage' | translate
            }}</div>
          </ng-container>
          <div *ngIf="scenario === 'aid' && asked" class="ld-msg ld-msg--user" [style.background]="paint.userBubbleFill" [style.color]="paint.userTextInk">{{ asked }}</div>
          <div class="ld-answer" [class.is-shown]="answered || !on"><ng-content></ng-content></div>
        </div>
        @if (view === 'profile') {
          <div class="ld-profile">
            <!-- Überschrift in der Canvas wie die echte App (nicht im Kopf) -->
            <p class="ld-view-title">{{ 'pages.chatStyling.preview.command.profile' | translate }}</p>
            <div class="ld-course">
              <div class="ld-course__top"><span>{{ 'pages.chatStyling.preview.command.course1' | translate }}</span><span>62 %</span></div>
              <div class="ld-track"><div class="ld-fill" style="width: 62%"></div></div>
            </div>
            <div class="ld-course">
              <div class="ld-course__top"><span>{{ 'pages.chatStyling.preview.command.course2' | translate }}</span><span>38 %</span></div>
              <div class="ld-track"><div class="ld-fill" style="width: 38%"></div></div>
            </div>
          </div>
        }
        <div class="ld-branding" *ngIf="styles.alphabeesBranding !== false">
          {{ 'pages.chatStyling.preview.brandingPrefix' | translate }} &nbsp;
          <img src="assets/images/Alphabees_LogoIcon_2026_indigo.svg" alt="" class="ld-branding__icon" />
          <span>Alphabees</span>
        </div>
      </div>
    </section>

    <!-- Vorschläge -->
    <div #suggest class="oc-suggest">
      <span class="oc-chip" style="--d: 0">{{ 'pages.chatStyling.preview.command.chip1' | translate }}</span>
      <span class="oc-chip" style="--d: 1">{{ 'pages.chatStyling.preview.command.chip2' | translate }}</span>
      <span class="oc-chip oc-chip--more" style="--d: 2"><svg viewBox="0 0 24 24"><circle cx="5.5" cy="12" r="1.9" /><circle cx="12" cy="12" r="1.9" /><circle cx="18.5" cy="12" r="1.9" /></svg></span>
    </div>

    <!-- Apps -->
    <nav #apps class="oc-apps">
      <span class="oc-app" data-app="profile" style="--i: 4" aria-pressed="false"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" /></svg></span>
      <span class="oc-app" data-app="materials" style="--i: 3" aria-pressed="false"><svg viewBox="0 0 24 24"><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5" /><path d="M3 17.5l9 5 9-5" /></svg></span>
      <span class="oc-app" data-app="exercises" style="--i: 2" aria-pressed="false"><svg viewBox="0 0 24 24"><path d="M4 20l1-4.5L15.5 5a2.1 2.1 0 0 1 3 3L8 18.5 4 20z" /><path d="M13.5 7l3 3" /></svg></span>
      <span class="oc-app" data-app="messages" style="--i: 1" aria-pressed="false"><svg viewBox="0 0 24 24"><rect x="2.5" y="4.5" width="19" height="15" rx="2.5" /><path d="M3 7l9 6 9-6" /></svg></span>
      <span class="oc-app" data-app="chat" style="--i: 0" aria-pressed="false"><svg viewBox="0 0 24 24"><path d="M5 4h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4V6a2 2 0 0 1 1-2z" /></svg></span>
    </nav>

    <!-- Leiste (Orbi steht daneben, siehe unten) -->
    <div class="oc-bar">
      <div class="oc-bar__row">
        <span #input class="ld-input">
          @if (typed) {
            <span class="ld-typed">{{ typed }}</span>
          } @else {
            <span class="ld-placeholder">{{ placeholderText || ('pages.chatStyling.preview.defaultPlaceholderLiquid' | translate) }}</span>
          }
          <i class="ld-caret" *ngIf="typing || typed"></i>
        </span>
        <span #send class="oc-send"><svg viewBox="0 0 24 24"><path d="M20.5 3.5 3.8 10.2c-.8.3-.7 1.4.1 1.6l6.6 1.7 1.7 6.6c.2.8 1.3.9 1.6.1z" /></svg></span>
      </div>
      <!-- Pop-up-Nachricht über Orbi (Liquid-Look) -->
      <div class="ld-popup" *ngIf="popup">
        <div class="ld-popup__card">
          <p class="ld-popup__kicker">{{ 'pages.chatStyling.preview.popupCategory' | translate }}</p>
          <p class="ld-popup__question">{{ 'pages.chatStyling.preview.popupQuestion' | translate }}</p>
        </div>
        <div class="ld-popup__replies">
          <span class="oc-chip ld-reply" style="--n: 0">{{ 'pages.chatStyling.preview.popupReplySummary' | translate }}</span>
          <span class="oc-chip ld-reply" style="--n: 1">{{ 'pages.chatStyling.preview.popupReplyNo' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Orbi bzw. Widget Trigger außerhalb der Leiste, links daneben -->
    <span #orbi class="oc-orbi" [class.is-hover]="orbiHover">
      <!-- Widget Trigger wie im Widget: Orbi, Dot oder Blob (Icon bzw. KI-Sterne) -->
      @switch (trigger) {
        @case ('dot') {
          <span class="oc-trigger oc-trigger--dot"><ng-container *ngTemplateOutlet="triggerIcon"></ng-container></span>
        }
        @case ('blob') {
          <span class="oc-trigger oc-trigger--blob"><i class="oc-blob__back"></i><i class="oc-blob__body"></i><ng-container *ngTemplateOutlet="triggerIcon"></ng-container></span>
        }
        @default {
          <app-orbi-lab class="oc-orbi__stage" type="tutor" [size]="58" [script]="orbiScript"></app-orbi-lab>
        }
      }
      <ng-template #triggerIcon>
        @if (styles.chatBubbleIcon) {
          @if (iconMaskUrl) {
            <span
              class="oc-trigger__icon oc-trigger__mask"
              [ngStyle]="{
                width: iconSize + 'px',
                height: iconSize + 'px',
                'background-color': iconColor,
                'mask-image': 'url(' + iconMaskUrl + ')',
                '-webkit-mask-image': 'url(' + iconMaskUrl + ')'
              }"
            ></span>
          } @else {
            <img class="oc-trigger__icon" [src]="styles.chatBubbleIcon" alt="" [style.width.px]="iconSize" [style.height.px]="iconSize" />
          }
        } @else {
          <svg class="oc-trigger__icon oc-trigger__sparkles" viewBox="0 0 24 24" [style.width.px]="iconSize" [style.height.px]="iconSize" [style.color]="iconColor">
            <path d="M14.5 5.5Q16 13 23 14.5Q16 16 14.5 23.5Q13 16 6 14.5Q13 13 14.5 5.5Z" />
            <path d="M6.5 3.5Q7.3 6.9 10.5 7.5Q7.3 8.1 6.5 11.5Q5.7 8.1 2.5 7.5Q5.7 6.9 6.5 3.5Z" />
            <path d="M12.5 0.8Q13 2.6 14.7 3Q13 3.4 12.5 5.2Q12 3.4 10.3 3Q12 2.6 12.5 0.8Z" />
          </svg>
        }
      </ng-template>
    </span>
  </div>

  <!-- 3D-Mauszeiger -->
  <div #cursor class="ld-cursor">
    <svg viewBox="0 0 32 32" width="44" height="44">
      <defs>
        <linearGradient id="ldCursorFace" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#ffffff" />
          <stop offset="0.55" stop-color="#f1f5f9" />
          <stop offset="1" stop-color="#b8c3d3" />
        </linearGradient>
      </defs>
      <path d="M6 3.5 L6 25 L11.2 20.2 L14.8 28.4 L19 26.6 L15.4 18.6 L22.6 18.4 Z" fill="url(#ldCursorFace)" stroke="#0f172a" stroke-width="2" stroke-linejoin="round" />
      <path d="M8.2 8 L8.2 19.6 L11 17" fill="none" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round" opacity="0.95" />
    </svg>
    <span class="ld-cursor__ripple"></span>
  </div>
</div>
